import { createSelector } from 'reselect';

import { getWorkspace } from './getWorkspace';

export const getSelectedRobotPartId = createSelector(
  getWorkspace,
  workspace => workspace.selectedRobotPartId
);
